import { render, staticRenderFns } from "./courseRecordDetails.vue?vue&type=template&id=5163f8c4&scoped=true"
import script from "./courseRecordDetails.vue?vue&type=script&lang=js"
export * from "./courseRecordDetails.vue?vue&type=script&lang=js"
import style0 from "./courseRecordDetails.vue?vue&type=style&index=0&id=5163f8c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163f8c4",
  null
  
)

export default component.exports